import ReactLocalization from 'react-localization';
import en from './strings/en.json';

const locale: {[key:string]: any} = new ReactLocalization({
    en
});

export default locale;
